import React from 'react';
import { Tv } from 'lucide-react';

// Pop-up shown to the customer before a CableTV payment — see utils/stbOnNotice.js.
// Nothing is charged until the payer presses "I understand". Wording is the owner's.
export default function StbOnNotice({ onConfirm, onCancel }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 10000, padding: 16,
    }} onClick={onCancel}>
      <div role="dialog" aria-modal="true" aria-labelledby="stb-on-title" style={{
        background: '#fff', borderRadius: 14, width: '100%', maxWidth: 380,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)', padding: '22px 20px',
      }} onClick={(e) => e.stopPropagation()}>
        <div style={{
          width: 46, height: 46, borderRadius: 12, background: '#ede9fe', display: 'flex',
          alignItems: 'center', justifyContent: 'center', marginBottom: 14,
        }}>
          <Tv size={22} color="#6d28d9" />
        </div>
        <div id="stb-on-title" style={{ fontSize: '1.02rem', fontWeight: 800, color: '#1e293b', marginBottom: 8 }}>
          Switch ON your Set-Top Box and TV
        </div>
        <div style={{ fontSize: '.87rem', color: '#475569', lineHeight: 1.55 }}>
          Before making your payment, please make sure that your Set-Top Box and TV are switched ON.
          <div style={{ marginTop: 8 }}>
            This will allow the recharge to be successfully processed and activated on your Set-Top Box without delay.
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
          <button type="button" className="btn btn-secondary" onClick={onCancel} style={{ flex: 1, justifyContent: 'center' }}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={onConfirm} style={{ flex: 2, justifyContent: 'center' }} autoFocus>
            I understand
          </button>
        </div>
      </div>
    </div>
  );
}
